import React from 'react';
import Logo from '../../assets/images/logo.png';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Success({ match }) {
    const { t } = useTranslation();
    return (
        <div className='splash'>
            <div className='flex05' />
            <div className='logoParent flex1'>
                <img src={Logo} alt='logo' />
            </div>
            <div>
                <p className='text-center'>
                    {t('Success page message')}
                </p>
                <p className='text-center'>
                    {/* شماره پرونده شما
                    { ` ${match.params.id} ` }
                    می باشد. */}
                    {t('Success page file number',{fileNum:match.params.id})}
                </p>
                <div className='text-center mt50'>
                    <Link className='btn btn-green btn-circle' to='/'>{t('Back to home')}</Link>
                </div>
            </div>
            <div className='flex05' />
        </div>
    );

}
